export default "__VITE_ASSET__7f200603__$_?nuxt_component=async&nuxt_component_name=SvgoFreelitecoin__"